import { PeerReference } from '~/types';
import { getData, patchData, postData } from '~/utils/service';
import { Events, GetReferenceResponseEvent } from './events';
import { PEER_REFERENCE_ROUTES } from './routes';
import { Context, Scope } from './types';

export { PEER_REFERENCE_ROUTES };

const PEER_REFERENCE = 'peerReference';

interface PeerReferenceRequestInput<T> {
  input: {
    context: Context;
    event: T;
  };
}

export const PEER_REFERENCE_API_CALLS = {
  get: async ({ input }: { input: Scope }): Promise<GetReferenceResponseEvent> =>
    await getData(PEER_REFERENCE, {
      pathParams: { magicLink: input.context.magicLink as string },
    }),
  patch: async ({ input }: PeerReferenceRequestInput<Events>): Promise<Partial<PeerReference>> => {
    return await patchData(PEER_REFERENCE, {
      data: input.context.peerReference,
      pathParams: { magicLink: input.context.magicLink as string },
    });
  },
  create: async ({ input }: PeerReferenceRequestInput<Events>): Promise<Partial<PeerReference>> => {
    return await postData(PEER_REFERENCE, {
      responseType: 'arraybuffer',
      data: input.context.peerReference,
      pathParams: { magicLink: input.context.magicLink as string },
    });
  },
};
